export default "./images/EDInfoNoCompassFix2.jpg";